export const faqs = [
  {
    id: 1,
    question: '黑料吃瓜网是什么网站？',
    answer: '黑料吃瓜网是全网热门黑料事件汇总与最新吃瓜爆料资讯一站式浏览平台。我们每日实时更新明星塌房、网红反差、不雅内幕、劲爆聊天记录等热门吃瓜内容，为用户提供最新最全的吃瓜资讯。',
  },
  {
    id: 2,
    question: '黑料吃瓜网的资讯来源可靠吗？',
    answer: '本站所有资讯均来自公开网络渠道，包括社交媒体、新闻报道、知情人士爆料等。我们会尽力核实信息真实性，但对于未经证实的爆料内容，我们会明确标注\"网传\"、\"爆料\"等提示，请用户理性看待。',
  },
  {
    id: 3,
    question: '网站内容多久更新一次？',
    answer: '黑料吃瓜网保持每日更新，热点事件实时跟进。工作日每日更新不少于10篇优质内容，周末和节假日也会有编辑值班确保热点事件第一时间发布。',
  },
  {
    id: 4,
    question: '如何投稿或爆料？',
    answer: '如果您有独家爆料内容，欢迎通过网站底部的\"联系我们\"页面与我们取得联系。我们会对爆料内容进行核实，核实通过后会注明爆料来源并第一时间发布。为保护爆料人隐私，我们接受匿名投稿。',
  },
  {
    id: 5,
    question: '网站上的吃瓜传送门是什么意思？',
    answer: '吃瓜传送门是指我们为用户整理的最新地址发布页和观看入口导航。由于网络环境变化，相关内容链接可能会更新，吃瓜传送门帮助用户快速找到最新可访问的入口，一键直达不打烊。',
  },
  {
    id: 6,
    question: '如果认为内容侵权如何投诉？',
    answer: '如果您认为本站发布的某些内容侵犯了您的合法权益，请通过底部联系邮箱发送投诉邮件，提供您的身份证明和相关证据。我们将在收到投诉后24小时内进行核实处理，对确有侵权的内容将立即删除。',
  },
];